import Joyride, {ACTIONS, EVENTS, STATUS} from 'react-joyride';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';

import TourCard from './tour-card.jsx';
import {endTour, setupTourStage} from '@explorer/actions/tour';
import {trackEvent} from '@explorer/analytics';
const defaultOptions = {
  zIndex: 1500,
};

const Tour = ({endTour, setupTourStage, tourState}) => {
  const [stepIndex, setStepIndex] = useState(tourState.index);

  // delay the setting of the next step so that we are sure
  // components are rendered if we need to open/close things
  useEffect(() => {
    const stage = tourState.steps[tourState.index];
    const delay = stage && stage.delay ? stage.delay : 300;
    setTimeout(() => {
      setStepIndex(tourState.index);
    }, delay);
  }, [tourState.index, tourState.steps]);

  const onTourChange = data => {
    const {action, index, type, status, step} = data;

    if (
      action === ACTIONS.CLOSE ||
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status)
    ) {
      trackEvent(`Tour ended`, {
        status:
          status === STATUS.FINISHED || index + 1 === tourState.steps.length
            ? 'finished'
            : 'closed',
        step: index + 1,
      });

      if (step.onEnd) {
        step.onEnd();
      }
      endTour(tourState.tour);
    } else if ([EVENTS.STEP_AFTER].includes(type)) {
      // Check whether next or back button click and update the step
      const newStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
      setupTourStage(newStepIndex);
    }
  };

  return (
    <Joyride
      run={tourState.run}
      stepIndex={stepIndex}
      continuous
      disableCloseOnEsc
      disableOverlayClose
      steps={tourState.steps}
      tooltipComponent={TourCard}
      styles={{options: defaultOptions}}
      callback={onTourChange}
      floaterProps={{disableAnimation: true}}
    />
  );
};

Tour.propTypes = {
  endTour: PropTypes.func,
  setupTourStage: PropTypes.func,
  tourState: PropTypes.object,
};

const mapStateToProps = state => ({
  tourState: state.tour,
});

const mapDispatchProps = {
  endTour,
  setupTourStage,
};

export default connect(mapStateToProps, mapDispatchProps)(Tour);
